<template>
  <div class="top" :style="{backgroundImage: `url(${img})`}">
    <div class="top_box">
      <div class="top_box_title">{{title}}</div>
      <div class="title_icon top_box_symbol"></div>
      <div class="top_box_content" v-html="content"></div>
      <img :src="imgMobile" class="top_right_img" />
      <div v-if="searchFlag&&!MobileFlag" class="top_box_search">
        <input class="top_box_search_text" type="input" :placeholder="searchPlaceholder" v-model="searchText"
          @input="$emit('input', searchText)" />
        <div class="top_box_search_button" @click="$emit('searchClick')">
          Search
        </div>
      </div>
    </div>
    <div :class="`mobile_search_box mobile_search_box_${this.$route.path.slice(1)}` ">
      <div v-if="MobileFlag" class="mobile_top_box_search">
        <input class="top_box_search_text" type="input" :placeholder="searchPlaceholder" v-model="searchText"
          @input="$emit('input', searchText)" />
        <div class="top_box_search_button" @click="$emit('searchClick')">
          Search
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import input from '../input/input.vue'
export default {
  // components: { input },
  name: 'top',
  props: ['title', 'subtitle', 'content', 'btn', 'img', 'imgMobile', 'searchFlag', 'searchPlaceholder'],
  data () {
    return {
      searchText: '',
      MobileFlag: false,
      pageList: [
        { name: 'Home', link: 'home' },
        { name: 'Services', link: 'services' },
        { name: 'Products', link: 'products' },
        { name: 'Blog', link: 'blog' },
        { name: 'Support', link: 'support' },
      ],
    }
  },
  created () {
    if (document.body.offsetWidth > 767) {
      this.MobileFlag = false
    } else {
      this.MobileFlag = true
    }
  }
}
</script>

<style scoped>
.top {
  width: 100%;
  background: #fff;
  position: relative;
  background-position: center;
  background-size: cover;
}
.top_box {
  width: 1200px;
  margin: 0 auto 0;
  height: 480px;
  text-align: center;
}
.top_box > div {
  position: relative;
  z-index: 1;
}
/* .top_box img{
    width: 100%;
    height: 480px;
    position: absolute;
    top: 0;
    left: 0;
  } */
.top_box_symbol {
  margin: 20px auto 40px;
}
.top_box_title {
  font-size: 40px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #ffffff;
  line-height: 40px;
  padding-top: 138px;
}
.top_box_content {
  font-size: 20px;
  font-family: Helvetica;
  color: #ffffff;
  line-height: 28px;
}
.top_right_img {
  display: none;
}
.top_box_search {
  display: flex;
  justify-content: center;
  margin-top: 71px;
}
.top_box_search_text {
  width: 632px;
  height: 50px;
  /* background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px 0 0 6px;
  text-indent: 12px;
  background: #FFFFFF; */
  border-radius: 4px 0px 0px 4px;
  border: 2px solid #ffffff;
  /* border: 2px solid #8d919b; */
  /* height: 48px;
  width: 410px; */
  cursor: pointer;
  padding-left: 24px;
  font-size: 16px;
  font-family: Helvetica;
}
.top_box_search_text:focus {
  border: 2px solid #fc5322;
  caret-color: #fc5322;
}
.top_box_search_text::placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.top_box_search_button {
  width: 120px;
  height: 50px;
  background: #fc5322;
  /* box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.12);
  border-radius: 0 6px 6px 0;
  text-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12); */
  line-height: 50px;
  font-size: 18px;
  font-family: Helvetica;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
  border-radius: 0 2px 2px 0;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
}
.top_box_search_button:hover,
.top_box_search_button:focus,
.top_box_search_button:active {
  background: #e34a1e;
  box-shadow: 0px 6px 8px 0px rgba(252, 83, 34, 0.1);
}

@media (max-width: 767px) {
  .top {
    background-image: none !important;
  }
  .top_box {
    width: 100%;
    height: auto;
    padding: 1.88rem 0.48rem 0;
  }
  .top_box_title {
    padding-top: 0.8rem;
    font-size: 0.58rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.58rem;
  }
  .top_box_symbol {
    margin: 0.3rem auto 0.27rem;
  }
  .top_box_content {
    font-size: 0.4rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.42rem;
  }
  .top_right_img {
    display: block;
    width: 100%;
    /* height: 2.88rem; */
    margin-top: 0.38rem;
  }
  .mobile_search_box {
    padding: 0.4rem 0.48rem 0;
    background: #ffffff;
  }
  .mobile_top_box_search {
    width: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
    box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.08rem 0 0 0.08rem !important;
  }
  .top_box_search_text {
    width: 5.03rem;
    height: 0.96rem;
    background: #ffffff;
    box-shadow: 0 0 0 0;
    font-size: 0.28rem;
    font-family: Helvetica;
    /* text-indent: 0.23rem; */
    border-radius: 0.08rem 0 0 0.08rem !important;
    border: 0px;
  }
  .top_box_search_text:focus {
    border: 0;
  }
  /* .top_box_search_text:focus {
    border: 0.02rem solid #fc5322;
    border-right: 0;
    caret-color: #fc5322;
  } */
  .top_box_search_button {
    width: 1.6rem;
    height: 0.96rem;
    background: #fc5322;
    box-shadow: 0 0 0 0;
    border-radius: 0.08rem;
    line-height: 0.96rem;
    font-size: 0.28rem;
    font-family: Helvetica-blod, Helvetica;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
    text-shadow: 0 0.04rem 0.08rem rgba(0, 0, 0, 0.12);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/top.vue